exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container {\r\n    text-align: center;\r\n    width: 100%;\r\n    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);\r\n    margin-bottom: 20px;\r\n    background-color: white;\r\n}\r\n\r\napp-round-info {\r\n    display: inline-block;\r\n    vertical-align: top;\r\n    margin-top: 50px;\r\n    margin-left: 50px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/intro-section/intro-section.component.css
// module id = 757
// module chunks = 1